import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calculator, ClipboardCheck, TrendingUp, Truck, ArrowRight } from 'lucide-react';

const BuyerLanding = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-blue-100">
      
      <section className="px-6 py-24 mx-auto max-w-7xl text-center md:py-32">
        <h1 className="text-5xl font-extrabold tracking-tight text-slate-900 sm:text-6xl md:text-7xl">
          {t('buyerLanding.heroTitlePart1')} <span className="text-blue-600">{t('buyerLanding.heroTitleHighlight')}</span>
        </h1>
        <p className="max-w-3xl mx-auto mt-6 text-xl text-slate-600 leading-relaxed">
          {t('buyerLanding.heroSub')}
        </p>
        <div className="flex flex-col sm:flex-row justify-center mt-10 gap-4">
          <a href="/register" className="px-8 py-4 text-lg font-bold text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors shadow-sm">
            {t('buyerLanding.ctaPrimary')}
          </a>
          <a href="/register" className="px-8 py-4 text-lg font-bold text-slate-700 bg-white border-2 border-slate-200 rounded-lg hover:border-slate-300 hover:bg-slate-50 transition-all flex items-center justify-center group">
            <Calculator className="w-5 h-5 mr-2 text-blue-600 group-hover:scale-110 transition-transform"/>
            {t('buyerLanding.ctaSecondary')}
          </a>
        </div>
      </section>

      <section className="py-24 bg-[#F8FAFC] border-t border-slate-200">
        <div className="px-6 mx-auto max-w-7xl">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            <div className="p-8 bg-white border border-slate-200 rounded-2xl shadow-sm">
              <div className="flex items-center justify-center w-14 h-14 mb-6 bg-blue-50 text-blue-600 rounded-xl"><ClipboardCheck className="w-7 h-7" /></div>
              <h3 className="mb-3 text-xl font-bold text-slate-900">{t('buyerLanding.feat1Title')}</h3>
              <p className="text-slate-600 leading-relaxed">{t('buyerLanding.feat1Desc')}</p>
            </div>
            <div className="p-8 bg-white border border-slate-200 rounded-2xl shadow-sm">
              <div className="flex items-center justify-center w-14 h-14 mb-6 bg-blue-50 text-blue-600 rounded-xl"><TrendingUp className="w-7 h-7" /></div>
              <h3 className="mb-3 text-xl font-bold text-slate-900">{t('buyerLanding.feat2Title')}</h3>
              <p className="text-slate-600 leading-relaxed">{t('buyerLanding.feat2Desc')}</p>
            </div>
            <div className="p-8 bg-white border border-slate-200 rounded-2xl shadow-sm">
              <div className="flex items-center justify-center w-14 h-14 mb-6 bg-blue-50 text-blue-600 rounded-xl"><Truck className="w-7 h-7" /></div>
              <h3 className="mb-3 text-xl font-bold text-slate-900">{t('buyerLanding.feat3Title')}</h3>
              <p className="text-slate-600 leading-relaxed">{t('buyerLanding.feat3Desc')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 text-center bg-white border-t border-slate-200">
        <div className="px-6 max-w-4xl mx-auto">
          <h2 className="mb-6 text-3xl font-bold text-slate-900 md:text-4xl">{t('buyerLanding.closeTitle')}</h2>
          <p className="mb-10 text-xl text-slate-600">{t('buyerLanding.closeSub')}</p>
          <a href="/register" className="inline-flex items-center px-8 py-4 text-lg font-bold text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors group">
            {t('buyerLanding.closeCta')}
            <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-1" />
          </a>
        </div>
      </section>
    </div>
  );
};

export default BuyerLanding;